<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2022-04-18 15:31:48
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Leave\LeaveTransactionPropertyGroup\LeaveTransactionPropertyGroup.vue
 -->
<template>
  <ContentLayout
    :addBtn="hasBtn('add-admin-leave-transaction-policy')"
    :title="$t('label_essweb_leaveTransactionPropertyGroup_list_title')"
    pad="0"
    @activated="activated"
    @new="toNew"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    :exportBtn="hasBtn('export-admin-leave-transaction-policy')"
    :importBtn="hasBtn('import-admin-leave-transaction-policy')"
    :import-options="{
      api: '/leave-transaction-type-property-group/import/',
      templateUrl:
        'https://assets.essencehr.io/web/ess-business/assets/leave-transaction-type-group-import-template.xlsx',
      success: (result) => {
        getList(null, 1, $tableSetting.perPageSize, null);
      },
    }"
    @export="onExport"
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :filter-page-data="filterPageData"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">
          <div
            class="text--primary table-title"
            :title="
              $getCommonLangValue(
                item.leave_transaction_type_property_group_name
              )
            "
          >
            {{
              $getCommonLangValue(
                item.leave_transaction_type_property_group_name
              )
            }}
          </div>
          <!-- <div class="text--secondary table-subtitle">
            {{
              $getCommonLangValue(
                item.leave_transaction_type_property_group_description
              )
            }}
          </div> -->
        </template>
        <template v-slot:item.code="{ item }">
          <div class="text--primary table-title">
            {{ item.leave_transaction_type_property_group_code }}
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-leave-transaction-policy')"
            :editBtn="hasBtn('edit-admin-leave-transaction-policy')"
            :viewBtn="hasBtn('view-admin-leave-transaction-policy')"
            :title="$t('label_essweb_leaveTransactionPropertyGroup_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "LeaveTransactionPG",
  computed: {},
  data() {
    return {
      showSelect: false,
      selected: [],
      totalCount: 0,
      headers: [
        {
          text: "label_essweb_leaveTransactionPropertyGroup_list_leaveTransactionPropertyGroupNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_leaveTransactionPropertyGroup_form_codeLabel",
          value: "code",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterPageData: null,
      filterObjects: [
        {
          type: "string",
          sequence: 0,
          name: "name",
          position: "right",
          label:
            "label_essweb_leaveTransactionPropertyGroup_list_leaveTransactionPropertyGroupNameLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
        {
          type: "string",
          sequence: 1,
          name: "code",
          position: "right",
          label: "label_essweb_leaveTransactionPropertyGroup_form_codeLabel",
          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
    };
  },
  mounted() {
    this.getBtnPermissionList();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "code") {
          data["leave_transaction_type_property_group_code_like"] = item.value;
        }
        if (item["name"] == "name") {
          data["leave_transaction_type_property_group_name"] = item.value;
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    onExport() {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "code") {
          data["leave_transaction_type_property_group_code_like"] = item.value;
        }
        if (item["name"] == "name") {
          data["leave_transaction_type_property_group_name"] = item.value;
        }
      });
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_property_group",
        url: "/leave-transaction-type-property-group/export/",
        data: data,
        type: "export",
        export_title: this.$t(
          "label_essweb_leaveTransactionPropertyGroup_list_title"
        ),
      });
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_property_group",
        url: "/leave-transaction-type-property-group/get-list/",
        data: data ? data : { cpage: page, pagesize: perpage },
      }).then((res) => {
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toNew: function () {
      this.$toPage("/admin/leave-transaction-policy/add", {});
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/leave-transaction-policy/edit/"
          : "/admin/leave-transaction-policy/detail/") + uuid
      );
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type_property_group",
        url: "/leave-transaction-type-property-group/delete/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_leaveTransactionPropertyGroup_list_deleteLeaveTransactionPropertyGroupNameLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
  },
};
</script>
